// src/data/m2/Unit10.js

export const M2_UNIT_10 = {
  id: "m2-u10",
  title: "Unit 10: Reasons & Logic",
  topic: "Why, Because & Idioms",
  iconType: "star", 
  grammarImage: "/m2-u10-grammar.jpg", 
  grammarText: "El gran final: Usamos **'Because'** para explicar razones, excusas y usar modismos como *'Kill two birds with one stone'*.",
  
  sets: [
    // ----------------------------------------------------------------------
    // SET 1: BASIC REASONING (Review)
    // Objetivo: Calentar motores con Why/Because.
    // ----------------------------------------------------------------------
    {
      id: "u26-set1",
      title: "Set 1: The Basics",
      questions: [
        { 
          type: "mc", 
          q: "___ are you happy? Because it's Friday!", 
          options: ["Why", "What", "When"], 
          a: "Why" 
        },
        { 
          type: "mc", 
          q: "I'm studying English ___ I want to travel.", 
          options: ["because", "but", "and"], 
          a: "because" 
        },
        { 
          type: "blank", 
          q: "She is tired ___ (porque) she works a lot.", 
          options: ["because"], 
          a: "because" 
        },
        { 
          type: "match", 
          q: "Conecta Causa y Efecto:",
          pairs: [
            { left: "I'm hungry", right: "Because I didn't eat" },
            { left: "I'm late", right: "Because of traffic" },
            { left: "I'm happy", right: "Because I passed the exam" }
          ],
          a: "completed"
        },
        { 
          type: "order", 
          q: "Ordena: ¿Por qué lloras?", 
          words: ["Why", "are", "you", "crying?"], 
          a: "Why are you crying?" 
        }
      ]
    },

    // ----------------------------------------------------------------------
    // SET 2: REAL EXCUSES (Daily Life)
    // Objetivo: Excusas creíbles (No "Because I want to").
    // ----------------------------------------------------------------------
    {
      id: "u26-set2",
      title: "Set 2: Good Excuses",
      questions: [
        { 
          type: "mc", 
          q: "Why didn't you call me? Because my battery ___.", 
          options: ["died", "dead", "finished"], 
          a: "died",
          successTip: "Decimos 'My battery died' (mi batería murió) cuando se acaba la carga."
        },
        { 
          type: "mc", 
          q: "Why are you late? Because I ___ the bus.", 
          options: ["missed", "lost"], 
          a: "missed",
          tip: "Perder un transporte es 'Miss'. Perder un objeto es 'Lose'."
        },
        { 
          type: "blank", 
          q: "I can't go ___ I have to work.", 
          options: ["because"], 
          a: "because" 
        },
        { 
          type: "order", 
          q: "Ordena: Me quedé dormido (razón de llegar tarde).", 
          words: ["Because", "I", "overslept."], 
          a: "Because I overslept." 
        },
        { 
          type: "input", 
          q: "Escribe: 'Porque estoy enfermo' (en inglés):", 
          a: "because I am sick" // Flexible
        }
      ]
    },

    // ----------------------------------------------------------------------
    // SET 3: IDIOMS - PART 1 (Efficiency)
    // Objetivo: Kill two birds with one stone.
    // ----------------------------------------------------------------------
    {
      id: "u26-set3",
      title: "Set 3: Smart Idioms",
      questions: [
        { 
          type: "mc", 
          q: "I cycle to work because I can ___ two birds with one stone.", 
          options: ["kill", "hit", "catch"], 
          a: "kill",
          successTip: "Significa lograr dos cosas a la vez (Ejercicio + Transporte)."
        },
        { 
          type: "match", 
          q: "Significado del modismo:",
          pairs: [
            { left: "Kill 2 birds with 1 stone", right: "Efficient (Eficiente)" },
            { left: "Piece of cake", right: "Easy (Fácil)" },
            { left: "Cost an arm and a leg", right: "Expensive (Caro)" }
          ],
          a: "completed"
        },
        { 
          type: "blank", 
          q: "This exam is easy. It's a piece of ___.", 
          options: ["cake"], 
          a: "cake" 
        },
        { 
          type: "mc", 
          q: "I didn't buy the car because it cost an arm and a ___.", 
          options: ["leg", "hand", "foot"], 
          a: "leg",
          tip: "Literalmente 'un ojo de la cara' en español."
        },
        { 
          type: "order", 
          q: "Ordena: Es pan comido (muy fácil).", 
          words: ["It's", "a", "piece", "of", "cake."], 
          a: "It's a piece of cake." 
        }
      ]
    },

    // ----------------------------------------------------------------------
    // SET 4: JOB INTERVIEW (Professional Reasons)
    // Objetivo: Venderse a uno mismo.
    // ----------------------------------------------------------------------
    {
      id: "u26-set4",
      title: "Set 4: The Interview",
      questions: [
        { 
          type: "mc", 
          q: "Why should we hire you? ___ I am hardworking.", 
          options: ["Because", "So"], 
          a: "Because" 
        },
        { 
          type: "mc", 
          q: "I want this job because I want to ___ experience.", 
          options: ["gain", "win", "earn"], 
          a: "gain",
          tip: "Experiencia se 'gana' (gain). Dinero se 'gana' (earn). Premios se 'ganan' (win)."
        },
        { 
          type: "blank", 
          q: "I like this company ___ it is innovative.", 
          options: ["because"], 
          a: "because" 
        },
        { 
          type: "order", 
          q: "Ordena: Porque soy organizado y puntual.", 
          words: ["Because", "I", "am", "organized", "and", "punctual."], 
          a: "Because I am organized and punctual." 
        },
        { 
          type: "input", 
          q: "Escribe: 'Trabajador' (en inglés - H...)", 
          a: "hardworking" 
        }
      ]
    },

    // ----------------------------------------------------------------------
    // SET 5: IDIOMS - PART 2 (Time & Luck)
    // Objetivo: Better late than never / Break a leg.
    // ----------------------------------------------------------------------
    {
      id: "u26-set5",
      title: "Set 5: More Idioms",
      questions: [
        { 
          type: "mc", 
          q: "Sorry I'm late! Well, better late than ___.", 
          options: ["never", "ever", "forever"], 
          a: "never",
          successTip: "Mejor llegar tarde que no llegar nunca."
        },
        { 
          type: "mc", 
          q: "You have an exam? Break a ___! (Good luck)", 
          options: ["leg", "arm", "head"], 
          a: "leg",
          tip: "Decir 'Good luck' en teatro da mala suerte, por eso dicen 'Break a leg'."
        },
        { 
          type: "blank", 
          q: "It's raining cats and ___ (lloviendo a cántaros).", 
          options: ["dogs"], 
          a: "dogs" 
        },
        { 
          type: "match", 
          q: "Conecta el significado:",
          pairs: [
            { left: "Break a leg", right: "Good luck" },
            { left: "Raining cats and dogs", right: "Heavy rain" },
            { left: "Better late than never", right: "Don't worry about delay" }
          ],
          a: "completed"
        },
        { 
          type: "order", 
          q: "Ordena: ¡Mucha suerte! (Modismo)", 
          words: ["Break", "a", "leg!"], 
          a: "Break a leg!" 
        }
      ]
    },

    // ----------------------------------------------------------------------
    // SET 6: MAKING DECISIONS (Review)
    // Objetivo: Justificar elecciones.
    // ----------------------------------------------------------------------
    {
      id: "u26-set6",
      title: "Set 6: Choices",
      questions: [
        { 
          type: "mc", 
          q: "I chose the salad because I'm on a ___.", 
          options: ["diet", "food", "hunger"], 
          a: "diet" 
        },
        { 
          type: "mc", 
          q: "I bought this phone because it was on ___.", 
          options: ["sale", "sell", "sold"], 
          a: "sale",
          tip: "'On sale' significa en oferta/rebaja."
        },
        { 
          type: "blank", 
          q: "I'm going home ___ I'm tired.", 
          options: ["because"], 
          a: "because" 
        },
        { 
          type: "order", 
          q: "Ordena: ¿Por qué compraste eso?", 
          words: ["Why", "did", "you", "buy", "that?"], 
          a: "Why did you buy that?" 
        },
        { 
          type: "input", 
          q: "Escribe: 'Dieta' (en inglés)", 
          a: "diet" 
        }
      ]
    },

    // ----------------------------------------------------------------------
    // SET 7: ERROR CORRECTION (Grammar Police)
    // Objetivo: Errores comunes con Why/Because.
    // ----------------------------------------------------------------------
    {
      id: "u26-set7",
      title: "Set 7: Find the Mistake",
      questions: [
        { 
          type: "mc", 
          q: "Error: 'Why you are crying?' (Order)", 
          options: ["Fix: Why ARE you...", "Fix: Why you IS..."], 
          a: "Fix: Why ARE you...",
          tip: "En preguntas, el verbo va antes del sujeto."
        },
        { 
          type: "mc", 
          q: "Error: 'I'm late because traffic.' (Noun phrase)", 
          options: ["Fix: because OF traffic", "Fix: because THE traffic"], 
          a: "Fix: because OF traffic",
          successTip: "Si sigue un sustantivo (traffic) usamos 'Because OF'. Si es frase (there is traffic), solo 'Because'."
        },
        { 
          type: "input", 
          q: "Corrige: 'Because I like.' (Incomplete)", 
          a: "Because I like it" 
        },
        { 
          type: "mc", 
          q: "Error: 'Better later than never.'", 
          options: ["Fix: Late", "Fix: Latest"], 
          a: "Fix: Late" 
        },
        { 
          type: "order", 
          q: "Corrige: Why you no happy?", 
          words: ["Why", "aren't", "you", "happy?"], 
          a: "Why aren't you happy?" 
        }
      ]
    },

    // ----------------------------------------------------------------------
    // SET 8: READING CONTEXT (The Letter)
    // Objetivo: Comprender razones en un texto.
    // ----------------------------------------------------------------------
    {
      id: "u26-set8",
      title: "Set 8: The Explanation",
      questions: [
        { 
          type: "mc", 
          q: "TEXT: 'I'm quitting my job ___ I found a better one.'", 
          options: ["because", "but"], 
          a: "because" 
        },
        { 
          type: "mc", 
          q: "TEXT: 'It wasn't an easy decision ___ I loved my team.'", 
          options: ["because", "so"], 
          a: "because" 
        },
        { 
          type: "blank", 
          q: "TEXT: 'However, the new job is a piece of ___.' (Easy)", 
          options: ["cake"], 
          a: "cake" 
        },
        { 
          type: "mc", 
          q: "Why did he quit?", 
          options: ["Found a better job", "Hated the team"], 
          a: "Found a better job" 
        },
        { 
          type: "order", 
          q: "Ordena: Fue una decisión difícil.", 
          words: ["It", "was", "a", "difficult", "decision."], 
          a: "It was a difficult decision." 
        }
      ]
    },

    // ----------------------------------------------------------------------
    // SET 9: COMPLEX SENTENCES (Because of)
    // Objetivo: Introducir 'Because of'.
    // ----------------------------------------------------------------------
    {
      id: "u26-set9",
      title: "Set 9: Because OF...",
      questions: [
        { 
          type: "mc", 
          q: "We stayed home because ___ the rain.", 
          options: ["of", "for", "by"], 
          a: "of",
          tip: "Because + Frase (Sujeto+Verbo). Because OF + Sustantivo."
        },
        { 
          type: "mc", 
          q: "I am happy ___ you.", 
          options: ["because of", "because"], 
          a: "because of" 
        },
        { 
          type: "blank", 
          q: "He is famous ___ (por) his music.", 
          options: ["because of"], 
          a: "because of" 
        },
        { 
          type: "match", 
          q: "Clasifica:",
          pairs: [
            { left: "Because...", right: "I was sick (Frase)" },
            { left: "Because of...", right: "The sickness (Sustantivo)" }
          ],
          a: "completed" 
        },
        { 
          type: "order", 
          q: "Ordena: Llegué tarde por el tráfico.", 
          words: ["I", "was", "late", "because", "of", "the", "traffic."], 
          a: "I was late because of the traffic." 
        }
      ]
    },

    // ----------------------------------------------------------------------
    // SET 10: MASTER CHALLENGE (Ultimate Logic)
    // Objetivo: Mezcla total.
    // ----------------------------------------------------------------------
    {
      id: "u26-set10",
      title: "Set 10: Logic Master",
      questions: [
        { 
          type: "mc", 
          q: "I exercise to kill two birds with one stone: health and fun.", 
          options: ["True usage", "False"], 
          a: "True usage" 
        },
        { 
          type: "order", 
          q: "Crea: No fui porque estaba quebrado.", 
          words: ["I", "didn't", "go", "because", "I", "was", "broke."], 
          a: "I didn't go because I was broke." 
        },
        { 
          type: "input", 
          q: "Traduce: 'Por el clima' (Because...)", 
          a: "because of the weather" 
        },
        { 
          type: "match", 
          q: "Ultimate Idioms:",
          pairs: [
            { left: "Piece of cake", right: "Easy" },
            { left: "Break a leg", right: "Good luck" },
            { left: "Cost an arm/leg", right: "Expensive" }
          ],
          a: "completed" 
        },
        { 
          type: "mc", 
          q: "Final: Why are you learning English? ___ it opens doors.", 
          options: ["Because", "Why"], 
          a: "Because" 
        }
      ]
    }
  ]
};